import Typography from "@@/elements/Typography";
import { PrimaryButtonProps } from "./buttonProps";
import styles from "./buttonStyles.module.scss";
import { File, Utilities } from "@@/elements/Icons/icons";
import Icon from "@@/elements/Icons/Icon";
import { formatLinkContent } from "./utils";

const PrimaryButton = ({
  disabled,
  onClick,
  label,
  title,
  href,
  target = "_self",
}: PrimaryButtonProps) => {
  if (href) {
    return (
      <a
        title={title}
        href={href}
        className={`${styles.base_button} ${styles.primary}`}
        target={target}
      >
          {formatLinkContent(href, label, target, "light")}
      </a>
    );
  }
  return (
    <button
      type="button"
      title={title}
      disabled={disabled}
      onClick={onClick}
      className={`${styles.base_button} ${styles.primary}`}
    >
      <Typography textcolor="light" variant="button">
        {label}
      </Typography>
    </button>
  );
};
export default PrimaryButton;
